export { default as AlignmentSettingsContext, useAlignmentSettings } from './alignment-settings-context';

export type { AlignmentSettings as AlignmentSettingsType } from './alignment-settings-context';
